/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UserStatusEnum {
    AwaitingСonfirmation = 0,
    ExpectsChanges = 1,
    Confirmed = 10,
    Blocked = -1,
}
